<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * IMPORT MODULE
 *
 * This module handles data imports across the platform.
 *
 * @package Import
 */

export default {
  name: 'Import',
  data () {
    return {
      isDisabled: (setting) => {
        // if (setting.status === null) return false
        return typeof setting.value === 'boolean'
          ? !setting.value
          : setting.status !== null && !this.$user.$.companySettings[setting.status]
      },

      backUrl: (url, setting) => {
        return setting.status !== null && !setting.value || setting.status === null && setting.value === false
          ? 'javascript:;'
          : url ? url.replace('[back]', '?back-to=Imports') : ''
      },

      hasPermission: (permission) => this.$user.$.userPermissions.indexOf(permission) > -1
    }
  },

  methods: {
    // Import cards flagged with `breakout` have no legacy module — the redesigned
    // native wizard is their only home (ticket 5854). So we always cancel the href
    // (it would otherwise be a dead link) and, when embedded in the v3 shell, post a
    // LEGACY_SHORTCUT_CLICK so the host routes to the native page. Standalone-legacy
    // is a safe no-op. Non-breakout cards are untouched — they navigate via href.
    onImport(setting, e) {
      if (!setting.breakout) return
      if (e && e.preventDefault) e.preventDefault()
      if (window.self === window.top) return
      // Pin the target origin to the actual embedder (the v3 shell) rather than '*'.
      let target = '*'
      try {
        if (document.referrer) target = new URL(document.referrer).origin
      } catch (err) { /* malformed referrer → fall back to '*' */ }
      window.parent.postMessage({ type: 'LEGACY_SHORTCUT_CLICK', button: setting.breakout }, target)
    }
  },

  computed: {
    settings() {
      let programsLabel = global.app.$user && global.app.$user.sessionSettings
        ? global.app.$user.sessionSettings.CompanySettings.ProgramsLabel
        : 'Programs'

      return [
        {
          name: programsLabel,
          condition: this.hasPermission('CreatePrograms'),
          status: null,
          // value: false,
          description: 'Import data to create and update ' + programsLabel.toLowerCase() + '.',
          configurable: 'Import',
          icon: ['far', 'calendar-alt'],
          url: '#/d/Import/Programs#import-file'// ,
          // endpoint: endpoints.import.programs
        },

        {
          name: 'Expenses',
          condition: this.hasPermission('CreateExpenses'),
          status: null,
          // value: false,
          description: 'Import data to create expenses.',
          configurable: 'Import',
          icon: ['fal', 'credit-card'],
          url: '#/d/Import/Expenses'// ,
          // endpoint: endpoints.import.expenses
        },

        {
          name: 'Invoices',
          condition: this.hasPermission('CreateEditPO'),
          status: null,
          // value: false,
          description: 'Import data to create invoices.',
          configurable: 'Import',
          icon: ['far', 'file-alt'],
          new: true,
          url: '#/d/Import/Invoices'// ,
          // endpoint: endpoints.import.invoices
        },

        {
          name: 'Categories',
          condition: this.hasPermission('Administration'),
          status: null,
          description: 'Import data to create and update categories from your chart of accounts.',
          configurable: 'Import',
          icon: ['far', 'list-alt'],
          new: true,
          // This card's Import button breaks out of the legacy iframe to the native
          // import wizard (ticket 5854); there is no legacy Categories import module,
          // so `onImport` always cancels navigation and the href is an inert
          // placeholder (never a dead route).
          breakout: 'ImportCategories',
          url: 'javascript:;'
        }/* ,

        {
          name: 'Divisions',
          status: null,
          value: false,
          description: 'Import data to create and update division configurations.',
          configurable: 'Import',
          icon: ['far', 'building'],
          url: '#/d/Import/Divisions'// ,
          // endpoint: endpoints.import.divisions
        },

        {
          name: 'Users',
          status: null,
          value: false,
          description: 'Import data to create and update user information.',
          configurable: 'Import',
          icon: ['fas', 'user'],
          url: '#/d/Import/Users'// ,
          // endpoint: endpoints.import.users
        } */
      ]
    }
  }
}
</script>

<!-- SETTINGS CARD TEMPLATE -->
<template lang="pug">
.content
  ed-title-nav(:title='$t("Import Data")')
  .container-fluid
    ed-section.active(offset=1)
      span(v-for='(setting, index) in settings')
        ed-card(
          :key='setting.name'
          :title='setting.name'
          :subtitle='setting.description.replace("[placeholder]", setting.name || setting.placeholder)'
          :footer-button='setting.configurable'
          :icon='setting.icon'
          :class='{ "new": setting.new }'
          :endpoint='setting.saving && (setting.endpoint || api.$.settings.company.$)'
          v-if='typeof setting.condition === "undefined" || setting.condition'
        )
          span(v-if='setting.help' slot='mask') {{ setting.help }}
          ed-switch(slot='top'
                    v-if='setting.status !== null'
                    :value='$user.$.companySettings[setting.status]'
                    v-model='settings[index].value'
                    @input='change(setting)'
                    @mousedown='handleEndpoint(setting)'
                    :emit-on-mount='false'
          )
          ed-input.small.inline(update-button
                                :disabled='isDisabled(setting)'
                                autofocus
                                helptipBody='You can change your division name here'
                                v-if='setting.editable'
                                v-model='setting.name'
                                @update='change(setting)'
                                @mousedown='handleEndpoint(setting)'
                                slot='title'
          )
          div(slot='footer')
            ed-button.btn.btn-actionbar-(@click='onImport(setting, $event)'
              :href='backUrl(setting.url, setting)'
              v-if='setting.configurable != "false"'
              :disabled='isDisabled(setting)'
              button-class='btn btn-actionbar-'
            ) {{ setting.configurable }}
</template>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/_modules/Import/index.vue